module.exports = __webpack_public_path__ + "img/gamad_matana_no.1494ca47.png";